import { gsap } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

export default function profileCardAnimations(section) {

    let rows = Array.from(section.querySelectorAll('.member-row')).forEach( row => {
        const blocks = Array.from(row.querySelectorAll('.profile-card'))

        if(blocks.length > 0) {

            gsap.timeline({
                scrollTrigger: {
                    trigger: blocks,
                    start: 'top 80%'
                }
            })
            .to(blocks, {
                opacity: 1,
                translateY: 0,
                stagger: index => {
                    // Add a little overlap
                    return index * 0.1 - (index * 0.025)
                }
            })
        }
    })
}
